// SO JSON → { header, table, lineCount }
// Works with the SO payload you shared (lineItems[].detail.*)
export function normalizeOrderForPacking(soRecord = {}) {
    if (!soRecord || typeof soRecord !== "object") {
        return { header: null, table: {}, lineCount: 0 };
    }

    const so = soRecord.soDetails || {};
    const dest = soRecord.destination || {};
    const src = soRecord.sourceDetail || {};

    // ---- Header for OrderDetails left box ----
    const header = {
        orderId: so.soNumber || soRecord.soNumber || soRecord._id,
        status: so.status || soRecord.status || "New",
        customer: dest.locationName || so.owner || "-",
        orderDate: so.orderDate ? new Date(so.orderDate).toLocaleString() : "-",
        deliveryAddress: [
            dest.addressLine1,
            dest.addressLine2,
            dest.city,
            dest.state,
            dest.country,
        ]
            .filter(Boolean)
            .join(", "),
        expectedDate: so.expectedReceiptDate
            ? new Date(so.expectedReceiptDate).toLocaleDateString()
            : "-",
        fromLocation: src.locationName || "-",
        toLocation: dest.locationName || "-",
    };

    // ---- Table rows grouped by SKU (SKU::<id>) ----
    const table = {};
    const items = Array.isArray(soRecord.lineItems) ? soRecord.lineItems : [];

    items.forEach((li, idx) => {
        const d = li?.detail || {};
        const skuId = d.skuId || d.item || `ROW${idx + 1}`;
        const key = `SKU::${skuId}`;

        if (!table[key]) table[key] = [];

        const expected = Number(d.orderedQty ?? 0);
        const packed = Number(d.dispatchQty ?? 0);

        table[key].push({
            lineNo: d.lineNumber || String(idx + 1).padStart(5, "0"),
            item: skuId,
            skuId,
            // show SO in the group header via headerLabelFormatter if you want
            salesOrder: d.salesOrder || so.soNumber || soRecord.soNumber,
            description: d.description || `Item ${skuId}`,
            uom: d.uom || "EA",
            expectedQty: expected,         // Order Qty
            openQty: Math.max(expected - packed, 0), // Pending Qty (derived)
            dispatchQty: packed,           // Packed Qty
            // you can stash any extra you need later:
            qcRequired: d.qcRequired ?? false,
            imageUrl: li.imageUrl || d.imageUrl || null, // optional
            __raw: li,
        });
    });

    table.__lastAddedTable = Object.keys(table)
        .filter((k) => !k.startsWith("__"))
        .slice(-1)[0];

    return {
        header,
        table,
        lineCount: items.length,
    };
}
